<template>
  <div ref="layout" v-loading="loading" class="page-form">
    <h3 class="title">新增物流异常单据</h3>
    <div class="form-container">
      <errors-list :errors="errorList" />
      <div v-if="conditions.status === 'E002'" class="tools">
        <form-button name="返回" @click="$router.go(-1)" />
      </div>
      <div v-if="conditions.status != 'E002'" class="tools">
        <form-button name="返回" @click="$router.go(-1)" />
        <form-button name="提交" icon="form-advance" @click="saveData('E002')" />
        <form-button name="保存" type="primary" @click="saveData('E001')" />
      </div>
      <el-form ref="form" inline size="mini" :show-message="false" :disabled="conditions.status === 'E002'" label-width="100px" :model="conditions" :rules="rules">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="异常单号" prop="dealers">
              <el-input
                v-model="conditions.abnoramlBillCode"
                placeholder="自动生成"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="billType" label="创建人" label-width="">
              <el-input
                v-model="conditions.createdByName"
                disabled
                placeholder="请输入"
                type="text"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="createdDate" label="创建日期" label-width="">
              <el-input v-model="conditions.createdDate" disabled placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="来源">
              <el-select
                v-model="conditions.source"
                disabled
              >
                <el-option v-for="item in selectDataOptions['WLYCSource']" :key="item.id" :value="item.value" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="要求处理时间" prop="requireProcessDate">
              <el-date-picker
                v-model="conditions.requireProcessDate"
                type="date"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="客户反馈情况" prop="responsecontent">
              <el-input
                v-model="conditions.responsecontent"
                placeholder="请输入"
                :autosize="{ minRows: 2, maxRows: 2 }"
                type="textarea"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.comment"
                placeholder="请输入"
                :autosize="{ minRows: 2, maxRows: 2 }"
                type="textarea"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="发货单明细" :custome-config="() => vxeShowCustom('xTable')">
        <template #button>
          <table-button tip="新增" name="add" @click="addRow" />
          <table-button tip="删除" name="delete" @click="delRow" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #wantCode="{ row }">
            <el-input
              v-model="row['wantCode']"
              placeholder="请选择"
              size="mini"
              @focus="openDialog($event, row)"
            />
          </template>
        </vxe-grid>
      </TableCommon>
      <TableCommon title="附件信息" :custome-config="() => vxeShowCustom('xTable3')">
        <template #button>
          <el-upload
            ref="upload"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="xTable3"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="100"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions2.columns"
          :data="gridOptions2.data"
        />
      </TableCommon>
    </div>

    <el-dialog v-dialogDrag :visible.sync="showDialog" title="要货单查询" width="70%">
      <select-deliver ref="dialogSelect" />
      <div slot="footer">
        <el-button size="small" type="default" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">确定</el-button>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { webUploadFile } from '@/api/common'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiSaveAbnormalLogistic, apiAbnormallogisticFindById } from '@/api/applyForGoods/logisticsAbnormal'
import SelectDeliver from '../../../../components/dialog/SelectDeliver'
import { apiFindDeliveryCheckoutGenerate } from '@/api/applyForGoods/logisticsAbnormal'

export default {
  name: 'logistics-exception-add',
  components: { SelectDeliver },

  data() {
    const rules = {
      requireProcessDate: [{ required: true, message: '请选择要求处理时间', trigger: 'change' }],
      responsecontent: [{ required: true, message: '请输入客户反馈情况', trigger: 'blur' }]
    }
    return {
      rules,
      loading: false,
      showDialog: false,
      selectDataOptions: {},
      errorList: [],
      clientDialog: false,
      currentRow: null,
      conditions: {
        abnoramlBillCode: '',
        wantCode: '',
        source: '1',
        handlefeedback: '',
        comment: '',
        content: '',
        customer: '',
        expirationDate: '',
        requireProcessDate: '',
        status: 'E001',
        createdDate: '',
        responsecontent: ''
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 30 },
          { field: 'wantCode', title: '发货单号', width: 100, slots: { default: 'wantCode' }},
          { field: 'customerName', title: '客户名称', width: 160 },
          { field: 'productDesc', title: '产品', width: 180 },
          { field: 'warehouseOut', title: '发货仓库', width: 100 },
          { field: 'createdDate', title: '申请时间', width: 140 },
          { field: 'wantQuantity', title: '申请量', width: 80 },
          // { field: 'payfreight', title: '应付运费', width: 120 },
          { field: 'shouldArrivedate', title: '应到货时间', width: 140 },
          { field: 'deliverQuantity', title: '实际发货量', width: 80 },
          //  { field: 'freight', title: '实际运费', width: 120 },
          { field: 'reachedTime', title: '安吉到货时间', width: 140 },
          { field: 'signdate', title: '客户签收时间', width: 140 },
          { field: 'receivecityname', title: '收货城市', width: 100 },
          { field: 'logisticno', title: '运单号', width: 100 },
          { title: '客户评价', field: 'commentResult', width: 100 },
          { title: '客户评价内容', field: 'feedbackByCustomer', width: 100 },
          { title: '签收备注', field: 'signRemark', width: 100 },
          { field: 'anjiRemark', title: '备注(安吉提供原因分类）', width: 200 }
        ],
        data: []
      },
      gridOptions2: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 50 },
          {
            field: 'fileName',
            title: '附件名称'
          },
          {
            field: 'fileKind',
            title: '附件类型'
          },
          {
            field: 'fileSize',
            title: '大小'
          },
          {
            field: 'createdDate',
            title: '上传时间'
          }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  watch: {
    'gridOptions2.data': {
      handler(val) {
        this.conditions.attachment = val
      },
      deep: true
    },
    'gridOptions.data': {
      handler(val) {
        this.conditions.abnormalDeliverList = val
      },
      deep: true
    },
    '$route.query': {
      handler(nv) {
        if (nv.id) {
          this.init(nv.id)
        } else if (nv.mode === 'local') {
          const wantids = nv.ids.split(',')
          apiFindDeliveryCheckoutGenerate({ wantCodes: wantids }).then(res => {
            this.gridOptions.data = res.data
          })
        } else {
          this.conditions = {
            abnoramlBillCode: '',
            wantCode: '',
            source: '1',
            handlefeedback: '',
            comment: '',
            content: '',
            customer: '',
            expirationDate: '',
            requireProcessDate: '',
            status: 'E001',
            createdDate: '',
            responsecontent: ''
          }
          this.gridOptions.data = []
          this.gridOptions2.data = []
        }
      },
      deep: true
    }
  },
  created() {
    this.getSelectDictDataOrigin('WLYCSource')
    this.conditions.createdDate = this.$utilsCommon.parseTime(
      new Date().getTime(),
      '{y}-{m}-{d}'
    )
    const { id, mode, ids } = this.$route.query
    if (id) {
      this.init(id)
    } else if (mode === 'local') {
      const wantids = ids.split(',')
      apiFindDeliveryCheckoutGenerate({ wantCodes: wantids }).then(res => {
        this.gridOptions.data = res.data
      })
    }
  },
  methods: {
    async init(id) {
      const { data } = await apiAbnormallogisticFindById({ id })
      Object.assign(this.conditions, data)
      this.gridOptions.data = data.abnormalDeliverList
      this.gridOptions2.data = data.attachment
    },
    openDialog(e, currentRow) {
      e.target.blur()
      this.showDialog = true
      currentRow && (this.currentRow = currentRow)
    },
    submitHandle() {
      const data = this.$refs.dialogSelect.submitForm()
      if (data) {
        // this.currentRow.wantCode = data.wantCode
        this.currentRow.wantCode = data.wantCode
        this.currentRow.customerCode = data.customerCode
        this.currentRow.customerName = data.customerName
        this.currentRow.remark = data.remark
        this.currentRow.productDesc = data.productDesc
        this.currentRow.warehouse = data.warehouse
        this.currentRow.wantDate = data.wantDate
        this.currentRow.wantQuantity = data.wantQuantity
        this.currentRow.payfreight = data.payfreight
        this.currentRow.shouldArrivedate = data.shouldArrivedate
        this.currentRow.deliverQuantity = data.deliverQuantity
        this.currentRow.freight = data.freight
        this.currentRow.arrivedate = data.arrivedate

        this.currentRow.signDate = data.signDate
        this.currentRow.receiveCityName = data.receiveCityName
        this.currentRow.commentResult = data.commentResult
        this.currentRow.feedbackByCustomer = data.feedbackByCustomer
        this.currentRow.signRemark = data.signRemark

        this.currentRow.anjiRemark = data.anjiRemark
      }
      this.showDialog = false
    },
    async saveData(type) {
      this.errorList = []
      if (this.gridOptions.data.length < 1) {
        this.errorList = ['请添加发货单明细！']
        return
      }

      this.$refs['form'].validate(async(valid, err) => {
        if (valid) {
          this.loading = true
          this.conditions.status = type
          const params = {
            ...this.conditions
          }
          try {
            const { data } = await apiSaveAbnormalLogistic(params)
            if (data.status === 'E001' || data.status === 'E002') {
              Object.assign(this.conditions, data)
              this.$message.success('操作成功！')
            } else {
              this.$message.error('操作失败！')
            }
          } catch (e) {
            //
          }
          this.loading = false
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          this.loading = false
          return false
        }
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    async delRow() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    addRow() {
      const row = {}
      this.gridOptions.columns
        .filter(v => !v.type)
        .map(v => v.field)
        .forEach(key => {
          row[key] = ''
        })
      this.gridOptions.data.unshift(row)
    },
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('bizId', 789456)
      formData.append('bizCode', 55552)
      formData.append('formSecretLevel', 0)
      formData.append('name', file.name)
      formData.append('type', file.raw.type)
      formData.append('lastModifiedDate', file.raw.lastModifiedDate)
      formData.append('size', file.size)
      formData.append('file', file.raw)
      const { data } = await webUploadFile(formData)
      data.file_id = data.id
      delete data.id
      this.gridOptions2.data.unshift(data)
    },
    // 删除附件
    delUpload() {
      const checkedList = this.$refs.xTable3.getCheckboxRecords()
      checkedList.forEach(item => {
        const index = this.gridOptions2.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions2.data.splice(index, 1)
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/components/LogisticsExceptionAdd.vue